import apiClient from './apiClient';

export interface QueryParams {
  vendorFrom?: string;
  vendorTo?: string;
}

export interface VendorQualRow {
  doc_no: string;
  vendor_type: string;
  dept_approval: string;
  dept_note: string;
  approved: boolean;
}

export interface ApproveItem {
  doc_no: string;
  dept_note: string;
}

export interface ApproveRequest {
  items: ApproveItem[];
}

export interface QueryResponse {
  data: VendorQualRow[];
  count: number;
  message?: string;
}

export interface ApproveResponse {
  approved_count: number;
  message?: string;
}

export const pw150hApi = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw150h/query', params);
    return res.data;
  },

  async approve(req: ApproveRequest): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pw150h/approve', req);
    return res.data;
  },

  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw150h/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
